module.exports = __webpack_public_path__ + "static/img/1029.45b0216.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1029.jpg
// module id = Q8LB
// module chunks = 1